<template>
  <section class="">
    <b-row class="">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="12" md="12">
        <b-card-actions action-collapse title="Add quotation">
          <b-row class="">
            <b-col cols="12" xl="12" md="12" class="mt-15">
              <h5>Reference</h5>
            </b-col>
            <b-col lg="12" md="12" sm="12" xs="12" cols="12">
              <b-form-group label-for="reference">
                <b-form-input
                  v-model="quoteData.reference"
                  placeholder="Reference"
                  required
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" xl="12" md="12" class="mt-15">
              <h5>Client</h5>
            </b-col>
            <b-col cols="12" xl="12" md="12">
              <v-select
                id="item-from"
                v-model="quoteData.customer"
                label="title"
                placeholder="Client"
                :options="clientList"
              >
                <!--<template #list-header>
                  <li
                    v-b-toggle.sidebar-add-new-customer
                    class="add-new-header d-flex align-items-center my-50 pl-1"
                  >
                    <feather-icon icon="PlusIcon" size="16" />
                    <span class="align-middle ml-25">Add Client</span>
                  </li>
                </template>-->
              </v-select>
            </b-col>

            <b-col cols="12" xl="12" md="12" class="mt-30">
              <h5>Route</h5>
            </b-col>
            <b-col cols="12" xl="6" md="6">
              <v-select
                id="item-from"
                v-model="quoteData.loadingPort"
                label="title"
                placeholder="From"
                :options="departurePorts"
                @input="updateArrivalPorts(quoteData.loadingPort)"
              >
                <!--<template #list-header>
                  <li
                    v-b-toggle.sidebar-add-new-agency
                    class="add-new-header d-flex align-items-center my-50 pl-1"
                  >
                    <feather-icon icon="PlusIcon" size="16" />
                    <span class="align-middle ml-25">Add Agency</span>
                  </li>
                </template>-->
              </v-select>
            </b-col>
            <b-col cols="12" xl="6" md="6">
              <v-select
                id="item-To"
                v-model="quoteData.dischargePort"
                label="title"
                placeholder="To"
                :options="arrivalPorts"
                @input="updateDeparturePorts(quoteData.dischargePort)"
              >
                <!--<template #list-header>
                  <li
                    v-b-toggle.sidebar-add-new-agency
                    class="add-new-header d-flex align-items-center my-50 pl-1"
                  >
                    <feather-icon icon="PlusIcon" size="16" />
                    <span class="align-middle ml-25">Add Agency</span>
                  </li>
                </template>-->
              </v-select>
            </b-col>

            <b-col cols="12" xl="12" md="12" class="mt-15">
              <v-select
                id="item-Incoterm"
                v-model="quoteData.incoterm"
                label="item-Incoterm"
                placeholder="Incoterm"
                :options="incotermArray"
              >
              </v-select>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              xs="6"
              cols="12"
              class="mt-15"
              v-if="quoteData.incoterm == 'EXW' || quoteData.incoterm == 'FCA'"
            >
              <b-form-group label-for="Incoterm">
                <v-select
                  id="Incoterm"
                  v-model="quoteData.transportType"
                  :options="TransportLoadingOptions"
                  required
                  class="input-outline-bleu-border"
                  placeholder="Transport Type"
                ></v-select>
              </b-form-group>
            </b-col>

            <b-col
              lg="6"
              md="6"
              sm="6"
              xs="6"
              cols="12"
              class="mt-15"
              v-if="
                quoteData.transportType == 'Transport Marchant' &&
                (quoteData.incoterm == 'EXW' || quoteData.incoterm == 'FCA')
              "
            >
              <b-form-group label-for="departureAddressCity">
                <b-form-input
                  v-model="quoteData.departureAddressCity"
                  placeholder="Adresse Depart City"
                  required
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              xs="6"
              cols="12"
              class="mt-15"
              v-if="quoteData.incoterm == 'DAP'"
            >
              <b-form-group label-for="Incoterm">
                <v-select
                  id="Incoterm"
                  v-model="quoteData.transportType"
                  :options="TransportLoadingOptions"
                  required
                  class="input-outline-bleu-border"
                  placeholder="Transport Type"
                ></v-select>
              </b-form-group>
            </b-col>

            <b-col
              lg="6"
              md="6"
              sm="6"
              xs="6"
              cols="12"
              class="mt-15"
              v-if="
                quoteData.transportType == 'Transport Marchant' &&
                quoteData.incoterm == 'DAP'
              "
            >
              <b-form-group label-for="arrivalAddressCity">
                <b-form-input
                  v-model="quoteData.arrivalAddressCity"
                  placeholder="adresse Arrival City"
                  required
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" xl="12" md="12" class="mt-30">
              <h5>Commodity</h5>
            </b-col>
            <b-col cols="12" xl="12" md="12">
              <v-select
                id="item-Commodity"
                v-model="quoteData.commodity"
                label="title"
                placeholder="Commodity"
                :options="commodities"
                @input="updateCommodity"
              >
                <template #list-header>
                  <li
                    v-b-toggle.sidebar-add-new-commodity
                    class="add-new-header d-flex align-items-center my-50 pl-1"
                  >
                    <feather-icon icon="PlusIcon" size="16" />
                    <span class="align-middle ml-25">Add commodity</span>
                  </li>
                </template>
              </v-select>
            </b-col>
            <b-col cols="12" xl="12" md="12" class="mt-15">
              <b-form-group>
                <b-form-radio-group
                  v-model="selectedOption"
                  class="commodity-radio-group"
                  @change="updateSelectedOption"
                >
                  <!--<b-form-radio value="radio1">
                                                  Peperishable cargo requiring temperature control
                                                </b-form-radio>-->
                  <b-form-radio value="radio2">
                    Cargo requiring special equipment
                  </b-form-radio>
                  <b-form-radio value="radio3"> Dangerous Cargo </b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <!--<b-col lg="4" md="4" sm="6" xs="12" cols="12" v-if="selectedOption==='radio1'">
                                            <b-form-group>
                                                <b-form-input
                                                id="temperature"
                                                placeholder="Temperature"
                                                v-model="quoteData.TemperatureControl"
                                                class="input-outline-bleu-border"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>-->
            <b-col
              lg="4"
              md="4"
              sm="6"
              xs="12"
              cols="12"
              v-if="selectedOption === 'radio2'"
            >
              <b-form-group>
                <b-form-input
                  id="height"
                  placeholder="Height"
                  v-model="quoteData.specialEquipment.height"
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col
              lg="4"
              md="4"
              sm="6"
              xs="12"
              cols="12"
              v-if="selectedOption === 'radio2'"
            >
              <b-form-group>
                <b-form-input
                  id="width"
                  placeholder="Width"
                  v-model="quoteData.specialEquipment.width"
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col
              lg="4"
              md="4"
              sm="6"
              xs="12"
              cols="12"
              v-if="selectedOption === 'radio2'"
            >
              <b-form-group>
                <b-form-input
                  id="length"
                  placeholder="Length"
                  v-model="quoteData.specialEquipment.length"
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              xs="12"
              cols="12"
              v-if="selectedOption === 'radio3'"
            >
              <b-form-group label-for="classe">
                <v-select
                  id="classe"
                  v-model="quoteData.commodityClass"
                  :options="classes"
                  label="title"
                  required
                  placeholder="classe"
                  @input="updateClasse"
                  class="input-outline-bleu-border"
                ></v-select>
              </b-form-group>
            </b-col>
            <b-col
              lg="6"
              md="6"
              sm="6"
              xs="12"
              cols="12"
              v-if="selectedOption === 'radio3'"
            >
              <b-form-group label-for="un">
                <v-select
                  id="un"
                  v-model="quoteData.commodityUn"
                  :options="uns"
                  placeholder="UN"
                  required
                  label="title"
                  class="input-outline-bleu-border"
                  @input="updateUn"
                ></v-select>
              </b-form-group>
            </b-col>

            <b-col cols="12" xl="12" md="12" class="mt-30">
              <h5>Container</h5>
            </b-col>
            <b-col cols="12" xl="12" md="12">
              <b-row v-for="(item, index) in quoteData.containers" :key="index">
                <b-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <b-form-group label-for="container">
                    <v-select
                      id="container"
                      v-model="item.containerType"
                      :options="containers"
                      required
                      label="title"
                      placeholder="Container type"
                      class="input-outline-bleu-border"
                      @input="updateContainer(index)"
                    ></v-select>
                  </b-form-group>

                  <b-form-group>
                    <b-form-checkbox
                      value="true"
                      v-model="item.isOwnedByShipper"
                      >Shipper owned container</b-form-checkbox
                    >
                  </b-form-group>
                </b-col>
                <b-col lg="3" md="3" sm="6" xs="12" cols="12">
                  <b-form-group label-for="Container-qte">
                    <b-form-spinbutton
                      id="Container-qte"
                      v-model="item.quantity"
                      min="1"
                      max="100000"
                      class="input-outline-bleu-border"
                    ></b-form-spinbutton>
                  </b-form-group>
                </b-col>
                <b-col lg="3" md="3" sm="6" xs="12" cols="12">
                  <b-form-group label-for="Container-quantity">
                    <b-form-input
                      placeholder="Container weight ( kg )"
                      v-model="item.weight"
                      @change="financial(item)"
                      required
                      id="Container-quantity"
                      disable
                      class="input-outline-bleu-border"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col lg="2" md="2" sm="12" xs="12" cols="12" v-if="index > 0">
                  <b-button
                    variant="danger"
                    class="addContainer"
                    @click="deleteContainer(item, index)"
                  >
                    Delete
                  </b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button
                    variant="primary"
                    class="addContainer"
                    @click="addContainer()"
                  >
                    Add an additional container
                  </b-button>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="12" xl="12" md="12" class="mt-30">
              <h5>Date</h5>
            </b-col>
            <b-col cols="12" xl="6" md="6">
              <b-form-datepicker
                id="Effective-datepicker"
                v-model="quoteData.effectiveDate"
                class="mb-1"
                placeholder="Effective date"
              />
            </b-col>
            <b-col cols="12" xl="6" md="6">
              <b-form-datepicker
                id="Expiry-datepicker"
                v-model="quoteData.expiryDate"
                class="mb-1"
                placeholder="Expiry date"
              />
            </b-col>

            <b-col class="text-right mt-30">
              <b-button
                variant="primary"
                class="addContainer"
                @click="addQuotation()"
              >
                Save
              </b-button>
            </b-col>
          </b-row>
        </b-card-actions>
      </b-col>
    </b-row>
    <sidebar-add-new-customer @update-client="getAllClient()" />
    <sidebar-add-new-agency @update-prospect="getAllCommodityAndContainers()" />
    <sidebar-add-new-commodity @update-payment="getAllCommodity()" />
  </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BFormSpinbutton,
  BFormDatepicker,
  BFormRadioGroup,
  BFormRadio,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import SidebarAddNewCustomer from "../../composants/sidebar/SidebarAddNewCustomer.vue";
import SidebarAddNewAgency from "../../composants/sidebar/SidebarAddNewAgency.vue";
import SidebarAddNewCommodity from "../../composants/sidebar/SidebarAddNewCommodity.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import axios from "@axios";

export default {
  components: {
    BFormDatepicker,
    BFormSpinbutton,
    BCardActions,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
    SidebarAddNewCustomer,
    SidebarAddNewAgency,
    SidebarAddNewCommodity,
    ToastificationContent,
    BFormRadioGroup,
    BFormRadio,
  },
  data() {
    return {
      clientList: [],
      ports: [],
      departurePorts: [],
      arrivalPorts: [],
      commodities: [],
      classes: [],
      uns: [],
      containers: [],
      TransportLoadingOptions: ["Transport Marchant", "Transport Carrier"],
      incotermArray: ["FOB", "CFR", "EXW", "FCA", "DAP"],
      selectedOption: null,
      quoteData: {
        reference: null,
        customer: null,
        arrivalPortAgent: null,
        departurePortAgent: null,
        loadingPort: null,
        dischargePort: null,
        incoterm: null,
        transportType: null,
        departureAddressCity: null,
        TransportDischarge: null,
        arrivalAddressCity: null,
        commodity: null,
        /*requiresTemperatureControl: false,*/
        requiresSpecialEquipment: false,
        dangerousCargo: false,
        TemperatureControl: null,
        commodityClass: null,
        commodityUn: null,
        specialEquipment: {
          height: null,
          width: null,
          length: null,
        },
        containers: [
          {
            containerType: null,
            quantity: 1,
            weight: "1000.000",
            isOwnedByShipper: false,
          },
        ],
        effectiveDate: null,
        expiryDate: null,
      },
      commodityState: false,
    };
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  created() {
    this.getAllClient();
    this.getPorts();
    this.getCommodities();
    this.getClasses();
    this.getUns();
    this.getContainers();
  },

  methods: {
    async getAllClient() {
      this.clientList = [];
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/customers"
      );
      response.data.data.forEach((element) => {
        this.clientList.push({
          _id: element.user._id,
          title: element.firstName + " " + element.lastName,
        });
      });
    },
    async getPorts() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/ports"
      );
      this.ports = response.data.data.map((item) => ({
        _id: item._id,
        portAgent: item.portAgent._id,
        title: item.title,
      }));
      this.departurePorts = this.ports;
      this.arrivalPorts = this.ports;
    },
    async getCommodities() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/commodities"
      );
      this.commodities = response.data.data.map((item) => ({
        _id: item._id,
        title: item.title,
      }));
    },
    async getClasses() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/classes"
      );
      this.classes = response.data.data.map((item) => ({
        _id: item._id,
        title: item.title,
      }));
    },
    async getUns() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/uns"
      );
      this.uns = response.data.data.map((item) => ({
        _id: item._id,
        title: item.title,
      }));
    },
    async getContainers() {
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/containers"
      );
      const uniqueSizes = new Set();
      const uniqueArray = response.data.data.filter((obj) => {
        if (!uniqueSizes.has(obj.sizeType)) {
          uniqueSizes.add(obj.sizeType);
          return true;
        }
        return false;
      });

      this.containers = uniqueArray.map((item) => ({
        // label: "Container " + item.type + "/" + item.size,
        title: "Container " + item.sizeType,
        _id: item._id,
      }));

      //   this.containers = response.data.data.map(item => ({
      //     _id : item._id,
      //     title : item.title,
      // }));
    },
    updateArrivalPorts(port) {
      this.quoteData.departurePortAgent = port ? port.portAgent : null;
      this.quoteData.loadingPort = port ? port.title : null;
      this.arrivalPorts = port
        ? this.ports.filter((item) => item.portAgent !== port.portAgent)
        : this.ports;
    },
    updateDeparturePorts(port) {
      this.quoteData.arrivalPortAgent = port ? port.portAgent : null;
      this.quoteData.dischargePort = port ? port.title : null;
      this.departurePorts = port
        ? this.ports.filter((item) => item.portAgent !== port.portAgent)
        : this.ports;
    },
    updateSelectedOption() {
      if (this.selectedOption === "radio1") {
        this.quoteData.requiresTemperatureControl = true;
        this.quoteData.requiresSpecialEquipment = false;
        this.quoteData.dangerousCargo = false;
        this.quoteData.specialEquipment.height = null;
        this.quoteData.specialEquipment.width = null;
        this.quoteData.specialEquipment.length = null;
        this.quoteData.commodityClass = null;
        this.quoteData.commodityUn = null;
      } else if (this.selectedOption === "radio2") {
        this.quoteData.requiresTemperatureControl = false;
        this.quoteData.requiresSpecialEquipment = true;
        this.quoteData.dangerousCargo = false;
        this.quoteData.TemperatureControl = null;
        this.quoteData.commodityClass = null;
        this.quoteData.commodityUn = null;
      } else if (this.selectedOption === "radio3") {
        this.quoteData.requiresTemperatureControl = false;
        this.quoteData.requiresSpecialEquipment = false;
        this.quoteData.dangerousCargo = true;
        this.quoteData.TemperatureControl = null;
        this.quoteData.specialEquipment.height = null;
        this.quoteData.specialEquipment.width = null;
        this.quoteData.specialEquipment.length = null;
      }
    },
    updateClasse() {
      this.quoteData.commodityClass = this.quoteData.commodityClass
        ? this.quoteData.commodityClass.title
        : null;
    },
    updateUn() {
      this.quoteData.commodityUn = this.quoteData.commodityUn
        ? this.quoteData.commodityUn.title
        : null;
    },
    updateContainer(index) {
      this.quoteData.containers[index].containerType = this.quoteData
        .containers[index].containerType
        ? this.quoteData.containers[index].containerType.title
        : null;
    },
    updateCommodity() {
      this.quoteData.commodity = this.quoteData.commodity
        ? this.quoteData.commodity.title
        : null;
    },
    addContainer() {
      this.quoteData.containers.push({
        containerType: null,
        quantity: 1,
        weight: "1000.000",
        isOwnedByShipper: false,
      });
    },
    financial(item) {
      item.weight = Number.parseFloat(item.weight).toFixed(3);
      return Number.parseFloat(item.weight).toFixed(3);
    },
    deleteContainer(item, index) {
      this.quoteData.containers.splice(index, 1);
    },
    addQuotation() {
      const filteredObj = Object.fromEntries(
        Object.entries(this.quoteData).filter(([key, value]) => value !== null)
      );
      if (this.quoteData.requiresSpecialEquipment === false) {
        delete filteredObj.specialEquipment;
      }
      filteredObj.customer = filteredObj.customer._id;
      axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/quotations",
          filteredObj
        )
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "quotation added",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during add",
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.commodity-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}
</style>

